import { fnGetUrl } from "functions/Api"

export const getTAmountMonth = () => {
    const apiRequest = {
        endpoint: '/api/ProvWeb/Supplier/TAmountMonth',
        useBasic: true
    }
    return fnGetUrl(apiRequest)
}
